/**
 * Srpski (latinica).
 *
 * Serbian has three plural forms, and they follow the last digit rather than
 * the size of the number: 21 takes the same form as 1. `lib/i18n.js` has the
 * rule; a message with a `count` gives `one`, `few` and `other`.
 */
export default {
  'date.today': 'Danas',
  'date.yesterday': 'Juče',
  'date.tomorrow': 'Sutra',
  'date.relative.today': 'danas',
  'date.relative.tomorrow': 'sutra',
  'date.relative.yesterday': 'juče',
  'date.relative.in': {
    one: 'za {count} dan',
    few: 'za {count} dana',
    other: 'za {count} dana',
  },
  'date.relative.ago': {
    one: 'pre {count} dan',
    few: 'pre {count} dana',
    other: 'pre {count} dana',
  },

  'update.ready': 'Nova verzija je spremna.',
  'update.detail': 'Možda donosi i osvežavanje tvojih podataka.',
  'update.now': 'Ažuriraj sada',

  'privacy.off': 'Privatnost isključena — sve je vidljivo',
  'privacy.on': 'Privatnost uključena — zbirni iznosi skriveni',
  'privacy.strict': 'Stroga privatnost — svi iznosi skriveni',

  'header.console': 'SQL konzola',
  'header.achievements': 'Dostignuća',
  'achievements.title': 'Dostignuća',
  'achievements.subtitle': 'Osvojeno {earned} od {total}',
  'achievements.since': 'Računa se od {date}, prvog dana korišćenja OKANE-a. Ništa pre toga se ne računa.',
  'achievements.counting': 'Računam…',
  'achievements.earnedOn': 'Osvojeno {date}',
  'achievements.unlocked': {
    one: 'Novo dostignuće: {names}',
    few: '{count} nova dostignuća: {names}',
    other: '{count} novih dostignuća: {names}',
  },
  'achievements.unit.months': { one: '{have} od {count} meseca', few: '{have} od {count} meseca zaredom', other: '{have} od {count} meseci zaredom' },
  'achievements.unit.days': { one: '{have} od {count} dana', few: '{have} od {count} dana', other: '{have} od {count} dana' },
  'achievements.unit.payments': { one: '{have} od {count} plaćanja', few: '{have} od {count} plaćanja', other: '{have} od {count} plaćanja' },
  'achievements.unit.goals': { one: '{have} od {count} cilja', few: '{have} od {count} cilja', other: '{have} od {count} ciljeva' },
  'achievement.saver.title': 'Štediša',
  'achievement.saver.desc': 'Mesec sa manjom potrošnjom nego prethodni.',
  'achievement.superSaver.title': 'Super štediša',
  'achievement.superSaver.desc': 'Tri meseca zaredom, svaki sa manjom potrošnjom od prethodnog.',
  'achievement.ultraSaver.title': 'Ultra štediša',
  'achievement.ultraSaver.desc': 'Šest meseci zaredom, svaki sa manjom potrošnjom od prethodnog.',
  'achievement.earner.title': 'Privređivač',
  'achievement.earner.desc': 'Mesec sa većim prihodima nego prethodni.',
  'achievement.superEarner.title': 'Super privređivač',
  'achievement.superEarner.desc': 'Tri meseca zaredom, svaki sa većim prihodima od prethodnog.',
  'achievement.ultraEarner.title': 'Ultra privređivač',
  'achievement.ultraEarner.desc': 'Šest meseci zaredom, svaki sa većim prihodima od prethodnog.',
  'achievement.inTheBlack.title': 'U plusu',
  'achievement.inTheBlack.desc': 'Mesec u kome je više novca ušlo nego što je izašlo.',
  'achievement.steadyHand.title': 'Sigurna ruka',
  'achievement.steadyHand.desc': 'Tri meseca zaredom u plusu.',
  'achievement.quietWeek.title': 'Mirna nedelja',
  'achievement.quietWeek.desc': 'Sedam dana zaredom bez ikakve potrošnje.',
  'achievement.perfectPlan.title': 'Savršen plan',
  'achievement.perfectPlan.desc': '50 planiranih plaćanja koja su stigla po planu.',
  'achievement.firstStep.title': 'Prvi korak',
  'achievement.firstStep.desc': 'Postavi svoj prvi cilj štednje.',
  'achievement.goalOriented.title': 'Usmeren ka cilju',
  'achievement.goalOriented.desc': 'Dostigni svoj prvi cilj štednje.',
  'achievement.overAchiever.title': 'Iznad očekivanja',
  'achievement.overAchiever.desc': 'Dostigni tri cilja štednje.',
  'achievement.accountant.title': 'Knjigovođa',
  'achievement.accountant.desc': '30 dana vođenja knjiga uz OKANE.',
  'achievement.ministerOfFinance.title': 'Ministar finansija',
  'achievement.ministerOfFinance.desc': '100 dana vođenja knjiga uz OKANE.',
  'header.lightTheme': 'Svetla tema',
  'header.darkTheme': 'Tamna tema',
  'header.menu': 'Meni',
  'header.import': 'Uvezi izvod',
  'header.export': 'Izvezi u CSV',
  'export.date': 'Datum',
  'export.description': 'Opis',
  'export.amount': 'Iznos ({currency})',
  'export.category': 'Kategorija',
  'export.tags': 'Oznake',
  'export.paymentType': 'Način plaćanja',
  'export.notes': 'Beleške',
  'export.status': 'Status',
  'export.pending': 'na čekanju',
  'export.nothing': 'Nema šta da se izveze — nijedna transakcija nije prikazana.',
  'export.done': {
    one: 'Izvezena {count} transakcija',
    few: 'Izvezene {count} transakcije',
    other: 'Izvezeno {count} transakcija',
  },
  'header.settings': 'Podešavanja',
  'header.help': 'Pomoć',

  'filter.currently': '{label}, trenutno {value}',
  'filter.remove': 'Ukloni filter „{label}“',
  'filter.search': 'Pretraga ili filter…',
  'filter.searchShort': 'Pretraga…',
  'filter.searchLabel': 'Pretraži transakcije',
  'filter.clearSearch': 'Obriši pretragu',
  'filter.add': 'Dodaj filter',
  'filter.noMatch': 'Nijedan filter se ne poklapa — traži se kao tekst.',
  'filter.clearAll': 'Obriši sve',

  'common.cancel': 'Otkaži',
  'common.apply': 'Primeni',
  'common.add': 'Dodaj',
  'common.save': 'Sačuvaj',
  'common.done': 'Gotovo',
  'common.delete': 'Obriši',
  'common.editThing': 'Izmeni {name}',
  'common.sure': 'Sigurno?',
  'common.exists': '„{name}“ već postoji.',
  'goals.emptyHint': 'Zadaj iznos i rok; OKANE postepeno odvaja svoj deo iz tvog stanja — bez ijedne transakcije.',
  'bulk.tagsHint': 'Označena oznaka je već na svima — izaberi je da je skineš. Isprekidana je na nekima; izaberi je da je dobiju i ostali, pa još jednom da je skineš sa svih. Naziv koji još ne postoji pravi se ovde.',
  'categorySheet.placeholder': 'Namirnice, Kirija, Plata…',
  'categorySheet.hint': 'Broj kaže koliko je transakcija u kategoriji. Oznaku na kategoriji nosi svaka od njih, a da se nigde ne kopira — skini je sa kategorije i sve je gube. Preimenovanje menja naziv u svim tvojim finansijskim podacima; brisanje skida samo naziv, a transakcije ostaju.',
  'tagSheet.hint': 'Broj kaže koliko transakcija nosi oznaku. Brisanje oznake skida je sa svih njih; same transakcije ostaju netaknute.',
  'console.runHint': '{keys} ga pokreće.',
  'console.ms': '{ms} ms',
  'import.or': 'ili',
  'import.sheetRows': {
    one: '{name} — {count} red',
    few: '{name} — {count} reda',
    other: '{name} — {count} redova',
  },
  'import.skippedN': 'preskočeno: {count}',
  'import.ignoredN': 'zanemareno: {count}',
  'import.andMore': 'i još {count}.',
  'import.failed': 'Ništa nije uvezeno: {reason}',
  'settings.readFailed': 'Datoteka nije mogla da se pročita: {reason}',
  'charts.maskedNote': '{caption}. Iznosi su sakriveni režimom privatnosti.',
  'app.attention': {
    one: '{count} stvar traži pažnju',
    few: '{count} stvari traže pažnju',
    other: '{count} stvari traži pažnju',
  },
  'backup.aesNote': 'Šifrovano pomoću AES-256. OKANE je ponovo otvara pod „Vrati“, a mogu i 7-Zip, Keka, WinZip i p7zip — ali ne i ugrađeni Archive Utility na macOS-u ni običan unzip, koji ovu vrstu lozinke nikad nisu naučili.',
  'backup.noWayBack': 'Bez lozinke nema povratka. Niko, pa ni OKANE, ne može da je povrati umesto tebe.',
  'backup.withoutPassword': 'Bez lozinke',
  'backup.backUp': 'Napravi kopiju',
  'backup.packing': 'Pakujem…',
  'error.zip.need-password': 'Za zaštitu rezervne kopije potrebna je lozinka.',
  'error.zip.not-zip': 'To nije zip datoteka.',
  'error.zip.not-ours': 'Taj zip nije zaštićen lozinkom na način na koji ih OKANE pravi.',
  'error.zip.wrong-password': 'Pogrešna lozinka.',
  'error.zip.damaged': 'Ta rezervna kopija je oštećena otkako je napravljena.',
  'error.zip.empty': 'U tom zipu nema ničega.',
  'error.sheet.empty': 'Ta datoteka je prazna.',
  'error.sheet.web-page': 'To je veb-stranica sačuvana kao .xls — izvezi je ponovo kao pravu Excel datoteku.',
  'error.sheet.not-excel': 'To nije Excel datoteka — izvezi izvod kao .xlsx ili .xls.',
  'error.sheet.no-workbook': 'U ovoj datoteci nema radne sveske.',
  'error.sheet.password': 'Ova datoteka je zaštićena lozinkom.',
  'error.sheet.no-worksheets': 'Ova radna sveska nema nijedan list.',
  'error.sheet.cannot-unzip': 'Ovaj pregledač ne ume da raspakuje .xlsx — sačuvaj tabelu kao .xls ili .csv.',
  'error.sheet.bad-xlsx': 'Ovo nije .xlsx datoteka koja može da se pročita.',
  'error.sheet.zip-not-sheet': 'Ova datoteka je zip, ali nije tabela.',
  'error.storage-lost': 'OKANE čuva podatke u datoteci koju ovaj pregledač više ne može da otvori. Koristi pregledač u kome je podešen.',
  'error.offline': 'OKANE server nije dostupan.',
  'error.disconnected': 'Veza sa serverom je prekinuta.',
  'error.refused': 'Server je odbio vezu.',
  'error.denied': 'Tvoja uloga u ovoj organizaciji to ne dozvoljava.',
  'error.signed-out': 'Sesija je istekla. Prijavi se ponovo.',
  'error.bad-email': 'To nije e-adresa.',
  'error.bad-name': 'Organizaciji treba naziv do 100 znakova.',
  'error.slow-down': 'Previše pokušaja. Pokušaj ponovo kasnije.',
  'error.mail': 'E-poruka nije mogla da se pošalje. Pokušaj ponovo za trenutak.',
  'error.link-expired': 'Link je istekao ili je već iskorišćen. Zatraži novi.',
  'error.ceremony': 'To je trajalo predugo. Pokušaj ponovo.',
  'error.passkey': 'Pristupni ključ nije prihvaćen.',
  'error.expired': 'Ovaj kod je istekao. Uzmi novi.',
  'error.last-owner': 'Organizacija mora da ima bar jednog vlasnika. Prvo postavi nekog drugog za vlasnika.',
  'error.server': 'Nešto je pošlo naopako na serveru.',
  'boot.backingUp': 'Pravim rezervnu kopiju podataka…',
  'boot.updating': 'Ažuriram tvoje podatke',
  'boot.savingCopy': 'Čuvam sigurnosnu kopiju pre ažuriranja.',
  'boot.almostThere': 'Još samo malo…',
  'boot.step': 'Korak {n} od {total}',
  'boot.awayWhile': 'Neko vreme te nije bilo — ažuriram tvoje podatke. Ne zatvaraj aplikaciju.',
  'boot.aheadTitle': 'Ažuriraj OKANE za nastavak',
  'boot.aheadLead': 'Ova kopija aplikacije je starija od tvojih podataka (v{app} naspram v{data}). Učitaj ponovo da dobiješ najnoviju verziju — podaci su netaknuti i bezbedni.',
  'boot.reload': 'Učitaj ponovo',
  'boot.errorTitle': 'Ažuriranje nije završeno',
  'boot.errorLead': 'Podaci nisu menjani posle poslednjeg završenog koraka, a rezervna kopija je napravljena pre toga. Možeš da pokušaš ponovo.',
  'boot.errorLeadBackup': 'Podaci nisu menjani posle poslednjeg završenog koraka, a rezervna kopija je napravljena pre toga. Možeš da pokušaš ponovo ili da preuzmeš kopiju napravljenu pre ažuriranja.',
  'boot.tryAgain': 'Pokušaj ponovo',
  'boot.downloadBackup': 'Preuzmi rezervnu kopiju',
  'boot.lockedTitle': 'OKANE je otvoren negde drugde',
  'boot.lockedLead': 'Druga kartica ili prozor u ovom pregledaču koristi tvoje podatke. Zatvori je pa pokušaj ponovo — dve kopije istovremeno bi prepisivale jedna drugu.',
  'boot.movingCloud': 'Premeštam tvoje finansijske podatke u oblak',
  'boot.movingDevice': 'Premeštam tvoje finansijske podatke na ovaj uređaj',
  'boot.movingLead': 'Kopiram je i proveravam svaki red pre nego što se stara kopija obriše. Ne zatvaraj aplikaciju.',
  'boot.moveFailedTitle': 'Finansijski podaci nisu premešteni',
  'boot.moveFailedLead': 'Ništa nije obrisano — tvoji finansijski podaci su i dalje tamo gde su bili, tačno onakvi kakvi su bili.',
  'boot.keepHere': 'Zadrži je na ovom uređaju',
  'boot.fatalTitle': 'OKANE nije mogao da se pokrene',
  'boot.needConnection': 'Za rad u oblaku potrebna je veza — ili čuvaj podatke na ovom uređaju.',
  'boot.serverBehind': 'Finansijski podaci na serveru su na šemi v{server}, a aplikacija očekuje v{app}. Server se ažurira — pokušaj ponovo za minut.',
  'common.xOfY': '{x} od {y}',

  'range.allTime': 'Sve vreme',
  'range.from': 'Od {day}',
  'range.upTo': 'Do {day}',
  'range.change': 'Period: {label}. Promeni ga',
  'range.title': 'Period',
  'range.fromLabel': 'Od',
  'range.toLabel': 'Do',
  'range.preset.thisMonth': 'Ovaj mesec',
  'range.preset.last7': 'Poslednjih 7 dana',
  'range.preset.last30': 'Poslednjih 30 dana',
  'range.preset.last3Months': 'Poslednja 3 meseca',
  'range.preset.thisYear': 'Ova godina',

  'goals.title': 'Ciljevi štednje',
  'goals.reached': 'Cilj dostignut',
  'goals.toGo': 'još {amount}',
  'goals.pace': '{amount} {cadence} · sledeće {day}',
  'goals.reachedOf': '{done} od {total} dostignuto',
  'goals.empty': 'Odluči za šta štediš',
  'goals.done': 'gotovo',

  'alerts.title': 'Van plana',
  'alerts.seen': '{matched}/{total} planiranih stavki viđeno',
  'alerts.less': 'Prikaži manje',
  'alerts.more': {
    one: 'Prikaži još {count}',
    few: 'Prikaži još {count}',
    other: 'Prikaži još {count}',
  },
  'alerts.allWell': 'Sve ide po planu',
  'alerts.allWellDetail': '{matched} od {total} planiranih stavki je na svom mestu.',

  'compare.title': 'Ovaj mesec u odnosu na prošli',
  'compare.titleThen': '{month} u odnosu na {previous}',
  'compare.income': 'Prihodi',
  'compare.spent': 'Potrošnja',
  'compare.saved': 'Štednja',
  'compare.top': 'Najveća kategorija',
  'compare.lastMonth': 'prošlog meseca',
  'compare.monthBefore': 'prethodnog meseca',
  'compare.up': 'više za {percent}% nego {than}',
  'compare.down': 'manje za {percent}% nego {than}',
  'compare.same': 'isto kao {than}',
  'compare.new': 'ništa {than}',
  'compare.none': 'ništa ni jednog meseca',
  'compare.was': 'bilo je {amount}',
  'compare.nothing': 'Nema',
  'section.hide': 'Sakrij: {name}',
  'section.show': 'Prikaži: {name}',
  'stats.title': 'Osnovni pokazatelji',
  'stats.balance': 'Stanje',
  'stats.projected': 'Projekcija za kraj meseca',
  'stats.allowance': 'Dnevni džeparac',
  'stats.daysLeft': {
    one: 'još {count} dan',
    few: 'još {count} dana',
    other: 'još {count} dana',
  },
  'stats.leftToday': 'još {amount} danas',
  'stats.thisMonth': 'Ovaj mesec',
  'stats.thatMonth': 'Taj mesec',
  'stats.spent': '{amount} potrošeno',
  'stats.net': '{amount} neto',
  'stats.stillToPay': 'Još za platiti',
  'stats.stillToPayLabel': 'Planirani troškovi koji još nisu plaćeni',
  'stats.allPaid': 'Sve plaćeno!',
  'stats.nothingPlanned': 'Ništa planirano',
  'stats.paidSoFar': '{amount} plaćeno do sada',
  'stats.plannedMeter': '{percent}% planiranih troškova ovog meseca je plaćeno',
  'stats.budgetsLabel': 'Budžeti',
  'stats.exactlyOnBudget': 'Tačno u budžetu',
  'stats.over': 'preko',
  'stats.under': 'ispod',
  'stats.budgetsSet': {
    one: '{count} postavljen',
    few: '{count} postavljena',
    other: '{count} postavljenih',
  },
  'stats.noneYet': 'Još nijedan',
  'stats.offTrack': {
    one: '{count} van plana',
    few: '{count} van plana',
    other: '{count} van plana',
  },
  'stats.budgetsHint': 'Postavi kategoriji granicu',
  'stats.budgetMeter': '{percent}% ukupnog budžeta za ovaj mesec',
  'stats.nextIn': 'Sledeći mesec prihodi',
  'stats.nextOut': 'Sledeći mesec troškovi',
  'stats.nextInLabel': 'Planirani prihodi za {month}',
  'stats.nextOutLabel': 'Planirani troškovi za {month}',
  'stats.plannedFor': 'planirano za {month}',
  'stats.plannedItems': {
    one: '{count} planirana stavka',
    few: '{count} planirane stavke',
    other: '{count} planiranih stavki',
  },
  'stats.saved': 'Ušteđeno',
  'stats.savedOf': 'od {amount}',
  'stats.savedThisMonth': '{amount} ovog meseca',
  'stats.noGoals': 'Još nema ciljeva štednje',
  'stats.savedMeter': '{percent}% svega za šta štediš',

  'common.edit': 'Izmeni',

  'ledger.title': 'Transakcije',
  'ledger.shown': {
    one: '{count} prikazana',
    few: '{count} prikazane',
    other: '{count} prikazanih',
  },
  'ledger.more': 'Prikaži još',
  'ledger.loading': 'Učitavanje…',
  'ledger.in': '{amount} ulaz',
  'ledger.out': '{amount} izlaz',
  'ledger.sortedBy': 'Sortirano po: {sort}, {dir}. Promeni sortiranje',
  'ledger.ascending': 'rastuće',
  'ledger.descending': 'opadajuće',
  'ledger.select': 'Izaberi',
  'ledger.duplicates': 'Duplikati',
  'duplicates.title': 'Mogući duplikati',
  'duplicates.subtitle': 'Isti način plaćanja, sličan iznos i opis, u kratkom razmaku.',
  'duplicates.found': {
    one: '{count} par izgleda kao ista uplata dvaput.',
    few: '{count} para izgledaju kao ista uplata dvaput.',
    other: '{count} parova izgleda kao ista uplata dvaput.',
  },
  'duplicates.daysApart': {
    one: '{count} dan razmaka',
    few: '{count} dana razmaka',
    other: '{count} dana razmaka',
  },
  'duplicates.similarity': 'Sličnost, najmanje',
  'duplicates.days': 'Razmak, najviše dana',
  'duplicates.amountApart': 'Razlika u iznosu, najviše',
  'duplicates.configRange': 'Sličnost i razlika u iznosu su 0–100%, razmak 0–365 dana.',
  'duplicates.configHint': 'Način plaćanja uvek mora biti isti, a uplata se nikad ne upari sa isplatom. Razlika od 0% znači isti iznos do pare.',
  'duplicates.alike': '{percent} slično',
  'duplicates.amountsDiffer': 'iznosi se razlikuju {percent}',
  'duplicates.none': 'Nema duplikata',
  'duplicates.noneHint': 'Nijedna stavka nije dovoljno slična nekoj drugoj.',
  'ledger.editAll': 'Izmeni sve',
  'ledger.selected': '{n} od {of} izabrano',
  'ledger.none': 'Nijedna',
  'ledger.all': 'Sve',
  'ledger.empty': 'Ovde još nema transakcija',
  'ledger.emptySearch': 'Ništa se ne poklapa sa pretragom',
  'ledger.emptyHint': 'Zabeleži šta se stvarno desilo — OKANE će to uporediti sa tvojim planom.',
  'ledger.emptySearchHint': 'Probaj drugi pojam ili proširi period na sve vreme.',
  'ledger.addTransaction': 'Dodaj transakciju',

  'kind.income': 'Prihod',
  'kind.expense': 'Trošak',
  'kind.saving': 'Štednja',

  'row.alreadySaved': 'Već ušteđeno',
  'row.setAside': 'Odvojeno',
  'row.unplanned': 'Neplanirano',

  'tabs.plan': 'Plan',
  'tabs.goals': 'Ciljevi',

  'plan.title': 'Plan',
  'plan.seen': '{matched}/{total} viđeno',
  'plan.missing': {
    one: '{count} nedostaje',
    few: '{count} nedostaju',
    other: '{count} nedostaje',
  },
  'plan.offAmount': {
    one: '{count} pogrešan iznos',
    few: '{count} pogrešna iznosa',
    other: '{count} pogrešnih iznosa',
  },
  'plan.nothing': 'Ništa nije zakazano tog meseca',
  'plan.auto': {
    one: 'automatski, prethodno',
    few: 'automatski, prosek {count}',
    other: 'automatski, prosek {count}',
  },
  'plan.autoLearning': 'automatski, još nema istorije',
  'plan.add': 'Novi plan',
  'plan.addLabel': 'Dodaj plan',
  'plan.income': 'Planirani prihodi',
  'plan.expenses': 'Planirani troškovi',
  'plan.empty': 'Nema planova za ovaj mesec',
  'plan.emptyHint': 'Dodaj platu i redovne račune — OKANE će ti javiti kad stvarnost odstupi.',
  'plan.seenOn': 'Viđeno {day}',
  'plan.due': 'Dospeva {day} · {relative}',

  'budgets.nothing': 'Ništa nije budžetirano tog meseca',
  'budgets.offTrackOf': '{off} od {total} van plana',
  'budgets.onTrack': {
    one: '{count} po planu',
    few: '{count} po planu',
    other: '{count} po planu',
  },
  'budgets.allOnTrackShort': 'sve po planu',
  'budgets.add': 'Novi budžet',
  'budgets.addLabel': 'Dodaj budžet',
  'budgets.empty': 'Nema budžeta ovog meseca',
  'budgets.emptyHint': 'Postavi granicu kategorijama ili oznakama — sve što pokrivaju, sabrano kroz ceo period.',
  'budgets.meter': '{category}, {percent}% budžeta',
  'budgets.auto': {
    one: 'automatski, prethodni period',
    few: 'automatski, prosek {count}',
    other: 'automatski, prosek {count}',
  },
  'budgets.editLabel': 'Izmeni budžet za {category}',

  'charts.title': 'Kretanja',
  'charts.tags': 'Oznake',
  'charts.categories': 'Kategorije',
  'charts.oneTag': 'oznaka',
  'charts.oneCategory': 'kategorija',
  'charts.balance': 'Stanje',
  'charts.runningTotal': 'Tekući zbir',
  'charts.balanceCaption': 'Stanje računa iz dana u dan, {window}',
  'charts.balanceCaptionSubset': 'Tekući zbir prikazanih transakcija iz dana u dan, {window}',
  'charts.flow': 'Prihodi i troškovi',
  'charts.flowSaved': 'Prihodi, troškovi i štednja',
  'charts.flowCaption': 'Prihodi i troškovi, {window}',
  'charts.flowSavedCaption': 'Prihodi, troškovi i odvojeno, {window}',
  'charts.in': 'Ulaz',
  'charts.out': 'Izlaz',
  'charts.savedSeries': 'Štednja',
  'charts.everyCategory': 'Sve kategorije',
  'charts.treemapCaption': 'Sve kategorije prema ukupnom prometu, ulazu i izlazu, {window}',
  'charts.treemapCaptionFor': 'Sve kategorije prema ukupnom prometu, za {subject}, {window}',
  'charts.nothingMoved': 'U ovom periodu nije bilo prometa',
  'charts.uncategorised': 'Bez kategorije',
  'charts.other': 'Ostalo',
  'charts.whereItGoes': 'Kuda odlazi',
  'charts.whereItComesFrom': 'Odakle dolazi',
  'charts.spendingByCategory': 'Troškovi po kategoriji',
  'charts.incomeByCategory': 'Prihodi po kategoriji',
  'charts.nothingOut': 'Ovde ništa nije izašlo',
  'charts.nothingIn': 'Ovde ništa nije ušlo',
  'charts.splitCaption': '{caption}, {window}',
  'charts.splitCaptionFor': '{caption} za {subject}, {window}',
  'charts.collapse': 'Skupi grafikone',
  'charts.expand': 'Raširi grafikone',
  'charts.day': 'Dan',
  'charts.month': 'Mesec',
  'charts.needAllTime': 'Prvo prebaci pregled na sve vreme',
  'charts.filtered': 'filtrirano',
  'charts.all': 'Sve',
  'charts.needALine': 'Prvo uključi neku oznaku ili kategoriju',
  'charts.maxLines': 'Najviše {count} linija odjednom.',
  'charts.chipLabel': '{name}, {family}',

  'cadence.once': 'Jednokratno',
  'cadence.weekly': 'Nedeljno',
  'cadence.fortnightly': 'Svake 2 nedelje',
  'cadence.monthly': 'Mesečno',
  'cadence.quarterly': 'Svaka 3 meseca',
  'cadence.yearly': 'Godišnje',

  'status.matched': 'Poklapa se',
  'status.over': 'Iznad plana',
  'status.under': 'Ispod plana',
  'status.missing': 'Nije viđeno',
  'status.due': 'Uskoro dospeva',
  'status.upcoming': 'Predstoji',

  'budgetStatus.learning': 'Još nema istorije',
  'budgetStatus.upcoming': 'Nije počeo',
  'budgetStatus.running': 'U toku',
  'budgetStatus.over': 'Preko budžeta',
  'budgetStatus.limit': 'Preko granice',
  'budgetStatus.short': 'Nedostaje',
  'budgetStatus.missed': 'Promašeno',
  'budgetStatus.under': 'Ispod budžeta',
  'budgetStatus.matched': 'U budžetu',
  'budgetStatus.matched.income': 'Na cilju',

  'common.confirmDelete': 'Dodirni za potvrdu',

  'goalSheet.new': 'Novi cilj štednje',
  'goalSheet.edit': 'Izmeni cilj',
  'goalSheet.subtitle': 'Koliko, i koliko brzo.',
  'goalSheet.goal': 'Cilj',
  'goalSheet.goalPlaceholder': 'Put u Japan, novi laptop, rezerva…',
  'goalSheet.target': 'Cilj (iznos)',
  'goalSheet.alreadySaved': 'Već ušteđeno',
  'goalSheet.byDate': 'Do datuma',
  'goalSheet.byAmount': 'Fiksan iznos',
  'goalSheet.reachBy': 'Dostići do',
  'goalSheet.putAside': 'Odvajaj {cadence}',
  'goalSheet.setAside': 'Odvajanje',
  'goalSheet.starting': 'Počinje',
  'goalSheet.setsAside': 'Odvaja {amount} {cadence}',
  'goalSheet.times': {
    one: '{count} put',
    few: '{count} puta',
    other: '{count} puta',
  },
  'goalSheet.lastOn': ', poslednji put {day}',
  'goalSheet.reaches': {
    one: 'Dostiže cilj {day}, posle {count} rate.',
    few: 'Dostiže cilj {day}, posle {count} rate.',
    other: 'Dostiže cilj {day}, posle {count} rata.',
  },
  'goalSheet.dayOne': 'prvog dana',
  'goalSheet.countsAsSaved': '{amount} od toga se već računa kao ušteđeno, pa toliko odmah odlazi iz tvog stanja. Ništa se ne prenosi — nijedna transakcija se ne beleži.',
  'goalSheet.archive': 'Arhiviraj ovaj cilj',
  'goalSheet.needName': 'Daj cilju ime.',
  'goalSheet.needTarget': 'Postavi ciljani iznos.',
  'goalSheet.needInstalment': 'Postavi koliko ćeš odvajati svaki put.',
  'goalSheet.updated': 'Cilj izmenjen',
  'goalSheet.added': 'Cilj dodat',
  'goalSheet.deleted': 'Cilj obrisan',

  'common.category': 'Kategorija',
  'common.amount': 'Iznos',
  'common.use': 'Koristi',
  'common.endsOn': 'Završava se',
  'common.optional': '(opciono)',

  'tolerance.exact': 'Tačno',

  'planSheet.edit': 'Izmeni plan',
  'planSheet.subtitle': 'Kategorija, po rasporedu: šta očekuješ da vidiš, i kada.',
  'planSheet.plannedExpense': 'Planirani trošak',
  'planSheet.categoryPlaceholder': 'Struja, Kirija, Plata…',
  'planSheet.repeats': 'Ponavlja se',
  'planSheet.firstDue': 'Prvi put dospeva',
  'planSheet.monthlyEquivalent': '{amount} mesečno u proseku',
  'planSheet.nextDue': 'Sledeće dospeće {day}',
  'planSheet.noFuture': 'Nema budućih dospeća',
  'planSheet.howItWorks': 'Kako ga OKANE prepoznaje',
  'planSheet.howItWorksDetail': 'Svaka transakcija u ovoj kategoriji, u odgovarajućem smeru, računa se u ono dospeće kojem je najbliža. Ništa se ne pamti i ništa se ne nagađa: premesti transakciju u drugu kategoriju i ona odgovara drugom planu.',
  'planSheet.flagIfOff': 'Upozori ako odstupa za',
  'planSheet.archive': 'Arhiviraj — prestani da ovo očekuješ',
  'planSheet.needCategory': 'Izaberi kategoriju na koju se plan odnosi.',
  'planSheet.auto': 'Odredi iznos prema prethodnim dospećima',
  'planSheet.autoPeriods': 'Broj dospeća za prosek',
  'planSheet.autoAverage': 'Prosek',
  'planSheet.autoPickFirst': 'Izaberi kategoriju da bi se video iznos.',
  'planSheet.autoNoHistory': 'Za prethodna dospeća ništa nije stiglo, pa iznosa nema dok nešto ne stigne.',
  'planSheet.autoShort': {
    one: 'Plaćeno je samo {count} od njih, pa je to sve što se uzima u prosek — ostala nisu stigla.',
    few: 'Plaćena su samo {count} od njih, pa je to sve što se uzima u prosek — ostala nisu stigla.',
    other: 'Plaćeno je samo {count} od njih, pa je to sve što se uzima u prosek — ostala nisu stigla.',
  },
  'planSheet.needPeriods': 'Prosek od najmanje 1, a najviše 120 dospeća.',
  'planSheet.needAmount': 'Unesi planirani iznos.',
  'planSheet.updated': 'Plan izmenjen',
  'planSheet.added': 'Plan dodat',
  'planSheet.deleted': 'Plan obrisan',

  'budgetSheet.edit': 'Izmeni budžet',
  'budgetSheet.subtitle': 'Kategorije i oznake, kroz ceo period: koliko sve to sme da bude.',
  'budgetSheet.limit': 'Granica potrošnje',
  'budgetSheet.target': 'Cilj prihoda',
  'budgetSheet.categories': 'Kategorije',
  'budgetSheet.coversHint': 'Transakcija se računa ako je u bilo kojoj od ovih kategorija ili nosi bilo koju od ovih oznaka — jednom, koliko god ih se poklapa.',
  'budgetSheet.categoryPlaceholder': 'Namirnice, Izlasci, Honorar…',
  'budgetSheet.every': 'Na svakih',
  'budgetSheet.inEffect': 'Važi od',
  'budgetSheet.periodRuns': 'Ovaj period traje {from} — {to}',
  'budgetSheet.howItWorks': 'Kako ga OKANE računa',
  'budgetSheet.howItWorksDetail': 'Svaka transakcija koju budžet pokriva, {direction}, sabira se kroz ceo period i meri prema ovom jednom iznosu. Ništa ne može da kasni, jer se ništa ne očekuje određenog dana — pogrešan može biti samo zbir.',
  'budgetSheet.comingIn': 'ulazna',
  'budgetSheet.goingOut': 'izlazna',
  'budgetSheet.warnShort': 'Upozori ako nedostaje',
  'budgetSheet.warnOver': 'Upozori ako pređe za',
  'budgetSheet.exactNote': 'Svako odstupanje se prijavljuje.',
  'budgetSheet.roomNote': '{amount} u oba smera prolazi bez reči.',
  'budgetSheet.archive': 'Arhiviraj — prestani da ovo računaš',
  'budgetSheet.needCategory': 'Izaberi bar jednu kategoriju ili oznaku koju budžet pokriva.',
  'budgetSheet.needPeriods': 'Prosek od najmanje 1, a najviše 120 perioda.',
  'budgetSheet.auto': 'Odredi iznos prema prethodnim periodima',
  'budgetSheet.autoPeriods': 'Broj perioda za prosek',
  'budgetSheet.autoPickFirst': 'Izaberi šta pokriva da bi se video iznos.',
  'budgetSheet.autoAverage': 'Prosek',
  'budgetSheet.autoShort': {
    one: 'Tvoje transakcije sežu unazad samo {count} period, pa je to sve što se uzima u prosek.',
    few: 'Tvoje transakcije sežu unazad samo {count} perioda, pa je to sve što se uzima u prosek.',
    other: 'Tvoje transakcije sežu unazad samo {count} perioda, pa je to sve što se uzima u prosek.',
  },
  'budgetSheet.autoNoHistory': 'Pre ovog perioda još nema transakcija, pa iznosa nema dok ga ne bude.',
  'budgetSheet.needAmount': 'Unesi iznos budžeta.',
  'budgetSheet.updated': 'Budžet izmenjen',
  'budgetSheet.added': 'Budžet dodat',
  'budgetSheet.deleted': 'Budžet obrisan',

  'common.close': 'Zatvori',
  'common.renameThing': 'Preimenuj {name}',
  'common.deleteThing': 'Obriši {name}',
  'common.searchCategories': 'Pretraži kategorije…',
  'common.searchTags': 'Pretraži oznake…',

  'picker.search': 'Pretraga…',
  'picker.chosen': 'izabrano',
  'picker.addAnother': 'Dodaj još…',
  'picker.clear': 'Ukloni {name}',
  'picker.hide': 'Sakrij listu',
  'picker.show': 'Prikaži listu',
  'picker.noMatch': 'Ništa se ne poklapa.',
  'picker.emptyList': 'Ovde još nema ničega — ukucaj ime.',

  'txSheet.new': 'Nova transakcija',
  'txSheet.edit': 'Izmeni transakciju',
  'txSheet.subtitle': 'Šta se stvarno desilo.',
  'txSheet.spent': 'Potrošeno',
  'txSheet.received': 'Primljeno',
  'txSheet.description': 'Opis',
  'txSheet.descriptionPlaceholder': 'Na šta je otišlo?',
  'txSheet.date': 'Datum',
  'txSheet.notes': 'Beleške',
  'txSheet.paymentType': 'Način plaćanja',
  'txSheet.paymentTypePlaceholder': 'Kartica, prenos… (neobavezno)',
  'txSheet.needAmount': 'Unesi iznos.',
  'txSheet.updated': 'Transakcija izmenjena',
  'txSheet.added': 'Transakcija dodata',
  'txSheet.deleted': 'Transakcija obrisana',

  'picker.make': 'Napravi',

  'charts.nothingYet': 'Još nema šta da se prikaže',

  'goals.newGoal': 'Novi cilj',

  'ledger.flipHint': 'Izaberi isto ponovo da obrneš redosled.',

  'sort.date': 'Datum',
  'sort.description': 'Opis',
  'sort.amount': 'Iznos',

  'backup.title': 'Rezervna kopija',
  'backup.subtitle': 'Kopija cele baze, sačuvana na ovaj uređaj.',
  'backup.password': 'Lozinka',
  'backup.again': 'I ponovo',
  'backup.passwordPlaceholder': 'Najmanje šest znakova',
  'backup.passwordHint': 'Šest znakova ili više.',
  'backup.mismatch': 'Ove dve se ne poklapaju.',
  'backup.downloaded': 'Rezervna kopija preuzeta',
  'backup.downloadedProtected': 'Rezervna kopija preuzeta, zaštićena lozinkom',

  'categorySheet.subtitle': 'Šta je transakcija, i oznake koje uz to idu.',
  'categorySheet.tagsOn': 'Oznake na: {name}',
  'categorySheet.newCategory': 'Nova kategorija',
  'categorySheet.empty': 'Još nema kategorija. Napravi jednu iznad, ili je jednostavno ukucaj na transakciji.',
  'categorySheet.created': 'Kategorija napravljena',
  'categorySheet.renamed': 'Preimenovano svuda',
  'categorySheet.deleted': 'Kategorija obrisana',
  'categorySheet.exists': '„{name}“ već postoji.',
  'categorySheet.tagsOnEverything': 'Oznake na svemu u kategoriji {name}',

  'bulk.title': {
    one: 'Izmeni {count} transakciju',
    few: 'Izmeni {count} transakcije',
    other: 'Izmeni {count} transakcija',
  },
  'bulk.subtitle': '{amount} ukupno. Menja se samo ono što uključiš.',
  'bulk.setCategory': 'Postavi kategoriju',
  'bulk.noCategory': 'Ništa nije izabrano — ako sada primeniš, kategorija se skida sa svih.',
  'bulk.setDescription': 'Postavi opis',
  'bulk.setNotes': 'Postavi beleške',
  'bulk.setPaymentType': 'Postavi način plaćanja',
  'bulk.descriptionPlaceholder': 'Šta su sve ovo bile',
  'bulk.applying': 'Primenjujem…',
  'bulk.updated': {
    one: '{count} transakcija izmenjena',
    few: '{count} transakcije izmenjene',
    other: '{count} transakcija izmenjeno',
  },
  'bulk.deleted': {
    one: '{count} transakcija obrisana',
    few: '{count} transakcije obrisane',
    other: '{count} transakcija obrisano',
  },

  'console.subtitle': 'Pravo u bazu. Ovde se ništa ne pita dvaput.',
  'console.tables': 'Tabele',
  'console.columnsOf': 'Kolone tabele {name}',
  'console.statement': 'Upit',
  'console.placeholder': 'SELECT * FROM transactions ORDER BY date DESC LIMIT 20;',
  'console.writes': 'Ovaj upit piše — nema poništavanja osim poslednje rezervne kopije.',
  'console.recent': 'Nedavno',
  'console.rows': {
    one: '{count} red',
    few: '{count} reda',
    other: '{count} redova',
  },
  'console.changed': {
    one: '{count} red promenjen',
    few: '{count} reda promenjena',
    other: '{count} redova promenjeno',
  },
  'console.noColumns': 'Nijedan red nije vraćen, pa nema ni kolona da se imenuju.',
  'console.footnote': 'Izvršava se doslovno, nad tvojim pravim podacima.',
  'console.run': 'Izvrši',
  'console.running': 'Izvršavam…',

  'import.title': 'Uvezi izvod',
  'import.subtitle': '.xlsx ili .xls izvod iz tvoje banke. Fajl nikada ne napušta ovaj uređaj.',
  'import.field.date': 'Datum',
  'import.field.description': 'Opis',
  'import.field.amount': 'Iznos',
  'import.field.type': 'Način plaćanja',
  'import.field.credit': 'Priliv',
  'import.field.debit': 'Odliv',
  'import.drop': 'Prevuci datoteku ovde',
  'import.chooseFile': 'Izaberi datoteku',
  'import.chooseAnother': 'Izaberi drugu',
  'import.reading': 'Čitam…',
  'import.sheet': 'List',
  'import.columns': 'Kolone',
  'import.datesReadAs': 'Datumi se čitaju kao',
  'import.dayFirst': 'Prvo dan',
  'import.monthFirst': 'Prvo mesec',
  'import.ready': 'Spremno za uvoz',
  'import.period': 'Period',
  'import.alreadyHere': 'Već u OKANE',
  'import.unreadableRows': 'Redovi bez datuma ili iznosa',
  'import.nothingReadable': 'Ništa čitljivo na ovom listu. Proveri raspored kolona iznad — OKANE-u trebaju bar datum i iznos.',
  'import.otherCurrency': 'Ovaj izvod je u {currency}',
  'import.otherCurrencyDetail': 'OKANE je podešen na {current}. Iznosi se uvoze onakvi kakvi jesu — prebaci OKANE na {other} da bi se ispravno čitali.',
  'import.footnote': 'Uvezeni redovi se automatski upoređuju sa tvojim planovima.',
  'import.clearPending': 'Očisti transakcije na čekanju',
  'import.updatePending': 'Osveži one na čekanju',
  'import.pendingSettled': {
    one: '{count} u međuvremenu proknjižena: osvežava se na mestu, kategorija i oznake ostaju.',
    few: '{count} u međuvremenu proknjižene: osvežavaju se na mestu, kategorije i oznake ostaju.',
    other: '{count} u međuvremenu proknjiženih: osvežavaju se na mestu, kategorije i oznake ostaju.',
  },
  'import.pendingGone': {
    one: '{count} više nije na ovom izvodu: uklanja se — banka ju je poništila ili proknjižila kao drugu stavku.',
    few: '{count} više nisu na ovom izvodu: uklanjaju se — banka ih je poništila ili proknjižila kao druge stavke.',
    other: '{count} više nije na ovom izvodu: uklanjaju se — banka ih je poništila ili proknjižila kao druge stavke.',
  },
  'import.importing': 'Uvozim…',
  'import.importN': 'Uvezi {count}',
  'import.imported': {
    one: '{count} transakcija uvezena',
    few: '{count} transakcije uvezene',
    other: '{count} transakcija uvezeno',
  },

  'settings.tab.general': 'Opšte',
  'settings.tab.suggestions': 'Predlozi',
  'settings.tab.sync': 'Sinhronizacija',
  'settings.tab.data': 'Tvoji podaci',
  'settings.tab.usage': 'Korišćenje',
  'usage.lead': 'Kako se OKANE koristi: anonimni dnevni zbirovi sa svih uređaja, čuvaju se na OKANE serveru. Posetioci se broje po danu, bez znanja ko su, pa se ista osoba u dva dana broji dvaput.',
  'usage.span': 'Period',
  'usage.lastDays': {
    one: 'poslednji {count} dan',
    few: 'poslednja {count} dana',
    other: 'poslednjih {count} dana',
  },
  'usage.refresh': 'Osveži',
  'usage.visitors': 'Posetioci',
  'usage.visitorDays': 'Posetioci, dan po dan',
  'usage.busiest': 'Najposećeniji dan',
  'usage.opens': 'Otvaranja',
  'usage.chartCaption': 'Posetioci i otvaranja po danu',
  'usage.nothing': 'U ovom periodu još ništa nije izbrojano.',
  'usage.more': '+još {count}',
  'settings.subtitle': 'Kako OKANE računa tvoj novac.',
  'settings.currency': 'Valuta',
  'settings.opening': 'Početno stanje',
  'settings.openingHint': 'Šta je bilo na računu pre prve transakcije.',
  'settings.currentBalance': 'Trenutno stanje',
  'settings.currentBalanceHint': 'Šta ti banka trenutno pokazuje. Ukucaj to i OKANE će pomeriti početno stanje da se poklopi — vredi uraditi kad uvezeš istoriju.',
  'settings.countUpcoming': 'Računaj i prihod koji još nije stigao',
  'settings.countUpcomingHint': 'Uključeno — trošiš na račun plate koju očekuješ. Isključeno — samo na račun novca koji je već na računu.',
  'settings.storage.opfs': 'Čuva se kao fajl u privatnom skladištu ovog pregledača.',
  'settings.storage.indexeddb': 'Čuva se u bazi ovog pregledača — on ne može da čuva fajlove.',
  'settings.storage.native': 'Čuva se kao fajl na ovom uređaju.',
  'settings.storage.protected': 'Zaštićeno: pregledač ga neće obrisati da bi oslobodio prostor.',
  'settings.storage.unprotected': 'Nije zaštićeno: pregledač može da ga obriše kada ponestane prostora. Instaliranje aplikacije OKANE na početni ekran to obično menja — i čuvaj rezervnu kopiju.',
  'settings.yourDataHint': 'Sve živi u SQLite bazi na ovom uređaju. Tvoji finansijski podaci se nikada ne šalju.',
  'settings.lockedFile': '{name} je zaštićena lozinkom.',
  'settings.itsPassword': 'Njena lozinka',
  'settings.restore': 'Vrati',
  'settings.sampleData': 'Probni podaci',
  'settings.loading': 'Učitavam…',
  'settings.eraseAll': 'Obriši sve',
  'settings.balanceMatched': 'Početno stanje podešeno da se poklopi',
  'settings.restored': 'Rezervna kopija vraćena',
  'settings.sampleLoaded': 'Probni podaci učitani',
  'settings.erased': 'Sve obrisano',
  'settings.footer': 'OKANE · offline-first · SQLite {transactions} transakcija, {plans} planova, {goals} ciljeva',
  'settings.openingFile': 'Otvaram…',

  'kindLabel.income': 'Primljeno',
  'kindLabel.expense': 'Potrošeno',
  'kindLabel.savings': 'Štednja',

  'filter.status': 'Status',
  'filter.pending': 'Na čekanju',
  'filter.settled': 'Proknjiženo',
  'filter.kind': 'Vrsta',
  'filter.tag': 'Oznaka',
  'filter.category': 'Kategorija',
  'filter.dateFrom': 'Datum od',
  'filter.dateTo': 'Datum do',
  'filter.amountFrom': 'Iznos od',
  'filter.amountTo': 'Iznos do',
  'filter.nothing': 'Ništa',
  'filter.or': 'ili',

  'alert.budgetOver': '{category} je {amount} preko budžeta',
  'alert.budgetOverLimit': '{category} je {amount} preko granice',
  'alert.budgetShort': '{category} je {amount} ispod cilja',
  'alert.budgetDetailRunning': '{actual} od {expected} do sada u ovom periodu.',
  'alert.budgetDetailDone': '{actual} od {expected} kroz ceo period.',
  'alert.notArrived': '{category} nije stigla',
  'alert.notShownUp': '{category} se nije pojavila',
  'alert.missingDetail': '{amount} je dospelo {when}. Još nema odgovarajuće transakcije.',
  'alert.dueToday': 'danas',
  'alert.dueDaysAgo': {
    one: 'pre {count} dan',
    few: 'pre {count} dana',
    other: 'pre {count} dana',
  },
  'alert.cameInHigher': '{category} je bila {amount} viša',
  'alert.cameInLower': '{category} je bila {amount} niža',
  'alert.varianceDetail': 'Planirano {expected}, stvarno {actual}.',
  'alert.incomeShort': 'Prihod je {amount} ispod plana',
  'alert.incomeOver': 'Prihod je {amount} iznad plana',
  'alert.incomeDetail': '{actual} primljeno naspram {planned} planiranih do sada ovog meseca.',
  'alert.monthShort': 'Projekcija: mesec se završava {amount} u minusu',
  'alert.monthShortDetail': 'Obaveze koje dospevaju premašuju stanje uvećano za očekivani prihod.',
  'alert.noneLeft': 'Nema više slobodnog trošenja ovog meseca',
  'alert.noneLeftDetail': 'Sve što je ostalo je već obavezano planovima i štednjom.',
  'alert.overToday': '{amount} preko današnjeg džeparca',
  'alert.overTodayDetail': 'Potrošeno {spent} naspram {perDay} dnevno.',

  'settings.language': 'Jezik',

  'budgets.title': 'Budžeti',

  'tagSheet.subtitle': 'Tvoje sopstvene oznake, na koliko god transakcija želiš.',
  'tagSheet.newTag': 'Nova oznaka',
  'tagSheet.placeholder': 'Odmor, Posao, Zajedničko…',
  'tagSheet.empty': 'Još nema oznaka. Napravi jednu iznad, pa je stavi na transakciju.',
  'tagSheet.created': 'Oznaka napravljena',
  'tagSheet.deleted': 'Oznaka obrisana',

  'suggest.title': 'Liči na',
  'suggest.applyAll': 'Primeni sve ovo',
  'suggest.reviewTitle': 'Na šta ovo liči',
  'suggest.reviewSubtitle': {
    one: '{count} uvezen red koji prepoznajem. Isključi ono što nije tačno.',
    few: '{count} uvezena reda koje prepoznajem. Isključi ono što nije tačno.',
    other: '{count} uvezenih redova koje prepoznajem. Isključi ono što nije tačno.',
  },
  'suggest.acceptAll': 'Uključi sve predloženo',
  'suggest.clearAll': 'Isključi sve',
  'suggest.apply': {
    one: 'Označi {count} red',
    few: 'Označi {count} reda',
    other: 'Označi {count} redova',
  },
  'suggest.applied': {
    one: '{count} red označen',
    few: '{count} reda označena',
    other: '{count} redova označeno',
  },
  'suggest.cancelKeeps': 'Otkazivanje zadržava uvoz i ostavlja redove bez oznaka.',
  'suggest.nothingToSay': 'Ništa ovde ne liči na ono što je već viđeno.',

  'lab.scoreboard': 'Kako mu ide',
  'lab.notEnough': 'Zasad samo {count} razvrstanih redova — premalo za ocenu. Razvrstaj još koji desetak pa se vrati.',
  'lab.categoryPrecision': 'Kategorija tačna',
  'lab.categoryCoverage': 'Kategorija ponuđena',
  'lab.tagPrecision': 'Oznake tačne',
  'lab.tagRecall': 'Oznake pronađene',
  'lab.f1': 'F1 za oznake',
  'lab.split': 'Učen na {trained} redova, ocenjen na {tested} najskorijih.',
  'lab.features': 'Šta čita',
  'lab.sweep': 'Pretraži',
  'lab.sweeping': 'Pretražujem…',
  'lab.sweepOf': 'Pretraga: {name}',
  'lab.value': 'Vrednost',
  'lab.useBest': 'Uzmi {value}',
  'lab.reset': 'Nazad na podrazumevano',
  'lab.footnote': 'Ništa odavde ne napušta uređaj, i ništa se ne uči dok se predlog ne zatraži. Sva podešavanja se čuvaju, pa eksperiment preživi osvežavanje.',
  'lab.learningRate': 'Brzina učenja',
  'lab.learningRateHint': 'Koliko svaki primer pomera težine. Previsoko i nikad se ne smiri.',
  'lab.epochs': 'Prolaza kroz transakcije',
  'lab.epochsHint': 'Više prolaza bliže prati istoriju, a na kraju i njene slučajnosti.',
  'lab.l2': 'Slabljenje težina (L2)',
  'lab.l2Hint': 'Vuče težine ka nuli, da jedna srećna reč ne odlučuje o svemu.',
  'lab.threshold': 'Sigurnost za predlog',
  'lab.thresholdHint': 'Ispod ovoga model ćuti. Više znači ređe predloge i ređe greške.',
  'lab.minExamples': 'Primera pre nego što oznaka vredi',
  'lab.minExamplesHint': 'Oznaka viđena jednom ili dvaput je slučajnost, ne obrazac.',
  'lab.minTokenLength': 'Najkraća reč koju vredi čitati',
  'lab.minTokenLengthHint': 'Izbacuje šum kojeg je izvod pun — pojedinačna slova, zalutale cifre.',
  'lab.maxTags': 'Najviše oznaka odjednom',
  'lab.maxTagsHint': 'Red sa devet pogođenih oznaka nije predlog nego nered.',
  'lab.bigrams': 'Parovi reči',
  'lab.bigramsHint': '„air serbia“ kao jedan trag umesto dva, što ga razdvaja od „air fryer“.',
  'lab.prefixes': 'Počeci reči',
  'lab.prefixesHint': 'Četiri slova svake reči, da MERCATOR i MERCATOR-S liče.',
  'lab.amount': 'Koliko je bilo',
  'lab.amountHint': 'Zaokruženo na red veličine: kirija i kafa ne liče.',
  'lab.weekday': 'Koji dan u nedelji',
  'lab.weekdayHint': 'Ponekad stvarno — petkom kupovina — a ponekad slučajnost kalendara.',

  'settings.suggestHint': 'OKANE uči šta su tvoje transakcije iz onih koje si već razvrstao.',

  'stats.inTheAccount': 'Na računu',

  'importer.generic': 'Obična tabela',

  'import.bank': 'Izvod iz',
  'import.settled': 'Proknjiženo od prošlog izvoza',
  'import.settledCount': {
    one: '{count} red, već ovde pod drugim datumom',
    few: '{count} reda, već ovde pod drugim datumima',
    other: '{count} redova, već ovde pod drugim datumima',
  },

  'importer.intesa': 'Banca Intesa',

  'import.bankInSettings': 'Podešava se u Podešavanjima, pored valute.',

  'settings.bank': 'Banka',
  'settings.bankHint': 'Kako OKANE čita izvod koji uvezeš.',

  'import.pending': 'Još nije proknjiženo',
  'import.pendingTag': 'na čekanju',
  'import.settlesTag': 'knjiži postojeći',
  'import.alreadyHereTag': 'već ovde',

  'row.pending': 'na čekanju',
  // --- Pomoć -----------------------------------------------------------------
  'help.title': 'Kako OKANE radi',
  'help.step': 'Korak {n} od {of}',
  'help.steps': 'Koraci',
  'help.goTo': 'Korak {n}: {title}',
  'help.next': 'Dalje',
  'help.back': 'Nazad',
  'help.openSettings': 'Otvori podešavanja',

  'help.transactions.title': 'Transakcije',
  'help.transactions.lead': 'Sve počinje od transakcije: jednog iznosa novca koji je ušao ili izašao, jednog dana.',
  'help.transactions.p1': 'Svaka ima datum, iznos i opis, a može imati i kategoriju, oznake, način plaćanja i beleške. Novac koji stiže je zelen.',
  'help.transactions.p2': 'Stanje, grafikoni, plan i budžeti izračunavaju se iz ovih stavki. Izmeni transakciju i sve ostalo se odmah menja sa njom.',
  'help.transactions.p3': 'Stavka označena kao NA ČEKANJU je plaćanje karticom koje banka još nije završila; proknjižiće se kada stigne neki kasniji izvod. Ljubičaste stavke su ono što su tvoji ciljevi štednje odvojili — vide se u listi, ali to nije novac koji se pomerio.',

  'help.inOut.title': 'Kako podaci ulaze i izlaze',
  'help.inOut.lead': 'Sve se čuva u bazi na ovom uređaju. Tvoji finansijski podaci se nikada ne šalju na internet, pa ih uvek premeštaš sam.',
  'help.inOut.p1': 'Dodaj transakciju ručno dugmetom + u uglu, ili dugmetom Dodaj iznad liste.',
  'help.inOut.p2': 'Uvezi izvod iz banke (.xlsx ili .xls) dugmetom za uvoz u zaglavlju. Prvo izaberi svoju banku u Podešavanjima: od nje zavisi kako se fajl čita. Stavke koje već imaš prepoznaju se i preskaču.',
  'help.inOut.p3': 'Napravi rezervnu kopiju iz Podešavanja → Rezervna kopija: cela baza u jednom fajlu zaštićenom lozinkom. Vrati je na ovom ili drugom uređaju iz Podešavanja → Vrati.',
  'help.inOut.p4': 'Za sve ostalo tu je SQL konzola u zaglavlju — prava baza, za direktne upite.',

  'help.categories.title': 'Kategorije',
  'help.categories.lead': 'Kategorija govori za šta je transakcija bila. Svaka transakcija ima najviše jednu.',
  'help.categories.p1': 'Planovi i budžeti rade po kategorijama: plan očekuje nešto u kategoriji Kirija oko prvog u mesecu, a budžet drži Namirnice i Izlaske na jednom iznosu mesečno.',
  'help.categories.p2': 'Novo ime otkucano bilo gde postaje nova kategorija. Kategorije preimenuješ ili brišeš preko ikonice fascikle u zaglavlju; preimenovanje povlači sa sobom sve transakcije.',
  'help.categories.p3': 'Kategorija može nositi oznake koje dobija sve što je u njoj. I svaki cilj štednje je svoja kategorija, pa može da se prikaže na grafikonu i filtrira.',
  'help.categories.p4': 'Kada razvrstaš nekoliko transakcija, OKANE počinje da predlaže kategoriju za nove.',

  'help.tags.title': 'Oznake',
  'help.tags.lead': 'Oznake su etikete, a transakcija može nositi koliko god želi — posao, odmor, poreska olakšica.',
  'help.tags.p1': 'Kategorija odgovara na pitanje šta je nešto bilo; oznake odgovaraju na sve ostalo što ćeš kasnije poželeti da pitaš.',
  'help.tags.p2': 'Stavi ih na jednu transakciju, na mnogo njih odjednom, ili na kategoriju da bi ih nosilo sve što je u njoj. Upravljaš njima preko ikonice oznake u zaglavlju.',
  'help.tags.p3': 'I oznake i kategorije mogu se prikazati kao linije na grafikonima — izaberi ih ispod grafikona — i po obema se može pretraživati i filtrirati.',

  'help.batches.title': 'Stotine odjednom',
  'help.batches.lead': 'Posle uvoza može biti na stotine stavki bez kategorije. Niko ih ne razvrstava jednu po jednu.',
  'help.batches.p1': 'Prvo suzi listu. Kucaj reči da pretražiš opise, ili filtere poput ovih ispod — samo nerazvrstane, samo potrošnju, samo velike iznose. Predlozi se pojavljuju dok kucaš.',
  'help.batches.p2': 'Zatim pritisni Izmeni sve: sve što lista prikazuje menja se zajedno. Postavi kategoriju, dodaj ili skini oznake, postavi način plaćanja ili beleške.',
  'help.batches.p3': 'Ponovi za sledeći obrazac — „lidl” u Namirnice, „shell” u Prevoz. Umesto toga, Izaberi služi da stavke biraš ručno, a Duplikati da nađeš ono što je uvezeno dvaput.',

  'help.ready.title': 'Srećno, i uživaj',
  'help.ready.lead': 'To je sve. Ova pomoć je uvek na dohvat ruke, iza znaka ? u zaglavlju.',
  'help.ready.p1': 'Počni od Podešavanja: izaberi valutu i banku, a kada uvezeš istoriju, upiši trenutno stanje da bi se brojevi slagali sa bankom.',
  'help.ready.p2': 'Ili, dok je OKANE još prazan, tamo učitaj Probne podatke da prvo razgledaš. Obriši sve ih ponovo uklanja.',
  // --- Oblak -----------------------------------------------------------------
  'settings.cloudHintLocal': 'Ovaj uređaj čuva svoje podatke. Premesti ih u oblak da bi ih koristio na svakom uređaju, ili da bi ih delio.',
  'settings.cloudHintCloud': 'Prijavljen kao {email} · {org}.',
  'settings.storage.cloud': 'Čuva se na OKANE serveru, u bazi tvoje organizacije.',
  'settings.yourDataHintCloud': 'Sve se čuva u bazi tvoje organizacije na OKANE serveru. Rezervna kopija i dalje preuzima primerak na ovaj uređaj.',
  'signin.title': 'Prijava na OKANE',
  'signin.lead': 'Tvoji finansijski podaci se čuvaju na OKANE serveru. Upiši svoju e-adresu i poslaćemo ti link — nova adresa pravi novi nalog.',
  'signin.moving': 'Čim se prijaviš, finansijski podaci sa ovog uređaja prelaze na server i ovde se brišu.',
  'signin.email': 'E-adresa',
  'signin.sendLink': 'Pošalji mi link za prijavu',
  'signin.passkey': 'Prijavi se pristupnim ključem',
  'signin.local': 'Ipak čuvaj podatke na ovom uređaju',
  'signin.sent': 'Proveri poštu — link je poslat na {email}. Radi jednom, 15 minuta.',
  'signin.noPasskey': 'Nijedan pristupni ključ nije izabran.',
  'signin.language': 'Jezik',
  'signin.showCode': 'Prikaži kod',
  'signin.scanCode': 'Skeniraj kod',
  'device.back': 'Nazad',
  'device.showTitle': 'Prijava telefonom',
  'device.showLead': 'Na telefonu na kome već koristiš OKANE otvori Podešavanja → Oblak i nalog → Dodaj uređaj → Skeniraj kod i usmeri ga ovamo.',
  'device.compare': 'Telefon će prikazati isti broj. Odobri samo ako se poklapaju.',
  'device.waiting': 'Čeka se telefon…',
  'device.expired': 'Ovaj kod je istekao.',
  'device.newCode': 'Prikaži novi kod',
  'device.scanTitle': 'Skeniraj kod',
  'device.scanLead': 'Na uređaju na kome već koristiš OKANE otvori Podešavanja → Oblak i nalog → Dodaj uređaj → Prikaži kod i usmeri kameru ka njemu.',
  'device.noCamera': 'Kamera nije mogla da se otvori: {reason}',
  'device.notOurs': 'To nije OKANE kod.',
  'device.signInFirst': 'Taj kod prijavljuje drugi uređaj — prvo se prijavi na ovom telefonu, pa ga skeniraj.',
  'device.signingIn': 'Prijava…',
  'device.sheetTitle': 'Dodaj uređaj',
  'device.showSheetLead': 'Skeniraj ovo telefonom koji dodaješ — u OKANE-u (Skeniraj kod) ili kamerom telefona. Radi jednom, 2 minuta.',
  'device.renewsIn': 'Novi kod za {seconds} s',
  'device.scanSheetLead': 'Na uređaju koji dodaješ otvori OKANE i na ekranu za prijavu izaberi Prikaži kod. Usmeri kameru ka njemu.',
  'device.approveTitle': 'Prijaviti taj uređaj?',
  'device.approveLead': 'Samo ako drugi ekran prikazuje tačno ovaj broj:',
  'device.unknown': 'Nepoznat uređaj',
  'device.approve': 'Prijavi ga',
  'device.approved': 'Drugi uređaj je prijavljen',
  'device.alreadyIn': 'Ovaj telefon je već prijavljen. Da dodaš drugi uređaj, skeniraj kod sa njegovog ekrana za prijavu.',
  'cloud.devices': 'Uređaji',
  'cloud.devicesHint': 'Dodaj telefon, tablet ili računar na ovaj nalog pomoću QR koda — telefon uvek skenira.',
  'cloud.joinByCode': 'Već koristiš OKANE na drugom uređaju? Skeniraj kod koji prikazuje (Dodaj uređaj → Prikaži kod) da ovde otvoriš isti profil. Profil ovog uređaja ostaje na njemu.',
  'cloud.title': 'Oblak',
  'cloud.gainDevices': 'Isti finansijski podaci na svakom uređaju, uvek ažurni.',
  'cloud.gainShare': 'Deli je — domaćinstvo, mala firma — svako sa svojom prijavom.',
  'cloud.costRead': 'Podaci se čuvaju na našem serveru i nisu šifrovani s kraja na kraj: mi možemo da ih pročitamo.',
  'cloud.costOffline': 'Potrebna je veza. U oblaku aplikacija ne radi bez interneta.',
  'cloud.org': 'Organizacija',
  'cloud.newOrg': 'Nova',
  'cloud.newOrgPlaceholder': 'Naziv nove organizacije',
  'cloud.members': 'Članovi',
  'cloud.role.owner': 'Vlasnik',
  'cloud.role.member': 'Član',
  'cloud.role.viewer': 'Posmatrač',
  'cloud.roleFor': 'Uloga za {email}',
  'cloud.removeFor': 'Ukloni {email}',
  'cloud.leave': 'Napusti organizaciju',
  'cloud.emailPlaceholder': 'njihov@email.com',
  'cloud.addPerson': 'Dodaj',
  'cloud.newRole': 'Uloga',
  'cloud.added': 'Dodato — prijavljuju se linkom poslatim na tu adresu',
  'cloud.rolesHint': 'Vlasnici upravljaju organizacijom i ljudima; članovi čitaju i pišu; posmatrači samo čitaju.',
  'cloud.passkeys': 'Pristupni ključevi',
  'cloud.noPasskeys': 'Još nijedan — prijavljuješ se linkovima iz e-pošte.',
  'cloud.passkeyName': 'Naziv ključa',
  'cloud.passkeyNamePlaceholder': 'npr. Moj telefon',
  'cloud.addPasskey': 'Dodaj pristupni ključ',
  'cloud.passkeyAdded': 'Pristupni ključ je dodat',
  'cloud.passkeyCancelled': 'Ključ nije napravljen.',
  'cloud.removePasskey': 'Ukloni ključ {name}',
  'cloud.reconnecting': 'Ponovno povezivanje sa serverom…',
  'cloud.moveUpHow': 'Tvoji finansijski podaci prelaze na server: kopiraju se, proveravaju red po red, a zatim brišu sa ovog uređaja. Ako već imaš profil u oblaku, ovo postaje zaseban profil.',
  'cloud.moveUp': 'Premesti moje finansijske podatke u oblak',
  'cloud.backupFirst': 'Pre selidbe sačuvaj svoju kopiju — fajl koji možeš vratiti bilo gde.',
  'cloud.backup': 'Preuzmi rezervnu kopiju',
  'cloud.backupProtected': 'Sa lozinkom…',
  'cloud.backedUp': 'Preuzeto',
  'cloud.moveDownTitle': 'Premesti na ovaj uređaj',
  'cloud.moveDownHow': 'Finansijski podaci se kopiraju na ovaj uređaj, proveravaju red po red, a zatim brišu sa servera. Ponovo rade bez interneta, i ima ih samo ovaj pregledač.',
  'cloud.moveDown': 'Premesti moje finansijske podatke na ovaj uređaj',
  'cloud.moveDownReplace': 'Zameni je i premesti',
  'cloud.moveDownShared': 'Ovaj profil dele i drugi, pa ostaje na serveru. Prvo ih ukloni da bi ga skinuo — ili preuzmi rezervnu kopiju.',
  'cloud.moveDownNotOwner': 'Samo vlasnik može da skine ovaj profil sa servera. Preuzmi rezervnu kopiju da sačuvaš njegovu kopiju.',
  'cloud.moveLocked': 'OKANE je otvoren u drugoj kartici ovog pregledača. Zatvori je, pa pokušaj ponovo.',
  'cloud.movedUp': 'Tvoji finansijski podaci su sada u oblaku — kopija na ovom uređaju je obrisana',
  'cloud.movedDown': 'Tvoji finansijski podaci su sada na ovom uređaju — kopija na serveru je obrisana',
  'cloud.serverCopyLeft': 'Finansijski podaci su ovde, ali njihova kopija na serveru još nije obrisana. OKANE će pokušati ponovo pri sledećem pokretanju.',
  'cloud.replaceLocal': {
    one: 'Na ovom uređaju već postoji profil ({count} transakcija). Selidba je zamenjuje.',
    few: 'Na ovom uređaju već postoji profil ({count} transakcije). Selidba je zamenjuje.',
    other: 'Na ovom uređaju već postoji profil ({count} transakcija). Selidba je zamenjuje.',
  },
  'cloud.signOut': 'Odjavi se',
  'cloud.denied': 'Tvoja uloga u ovoj organizaciji je samo čitanje — ništa nije promenjeno.',
  'cloud.disconnected': 'Veza sa serverom je prekinuta, pa to nije sačuvano. Pokušaj ponovo za trenutak.',
  'sync.gainPrivate': 'Finansijski podaci se šifruju na ovom uređaju pre nego što ga napuste: server ne može da pročita nijedan iznos.',
  'sync.gainOffline': 'Ostaje na ovom uređaju i radi bez mreže; izmene putuju kad se veza vrati.',
  'sync.costLost': 'Ako zaboraviš lozinku i izgubiš ključ za oporavak, niko — pa ni mi — ne može ponovo da je otvori.',
  'sync.signInFirst': 'Prvo se prijavi. Ovaj uređaj ostaje lokalan dok se finansijski podaci ne presele: prijava samo govori ko si.',
  'sync.sendLink': 'Pošalji mi link',
  'sync.linkSent': 'Link za prijavu stiže na {email}. Otvori ga na ovom uređaju.',
  'sync.signedInAs': 'Prijavljen si kao {email}',
  'sync.recoveryPlaceholder': 'Ključ za oporavak',
  'sync.passphrase': 'Lozinka',
  'sync.passphraseAgain': 'Ponovi lozinku',
  'sync.usePassphrase': 'Koristi lozinku',
  'sync.useRecovery': 'Zaboravio si je? Koristi ključ za oporavak',
  'sync.newTitle': 'Sinhronizuj ovaj profil',
  'sync.newLead': 'Izaberi lozinku. Upisaćeš je na drugim uređajima — ili ćeš ih umesto toga odobriti odavde.',
  'sync.name': 'Naziv',
  'sync.defaultName': 'Lično',
  'sync.passphraseShort': 'Najmanje {n} znakova.',
  'sync.passphraseDiffers': 'Lozinke se razlikuju.',
  'sync.turnOn': 'Uključi šifrovanu sinhronizaciju',
  'sync.turningOn': 'Šifrujem finansijske podatke…',
  'sync.recoveryTitle': 'Tvoj ključ za oporavak',
  'sync.recoveryLead': 'Zapiši ga i čuvaj na sigurnom. Otvara tvoje finansijske podatke ako zaboraviš lozinku, a prikazuje se samo ovaj put.',
  'sync.recoveryDone': 'Zapisao/la sam ga',
  'sync.status.off': 'Nije uključeno',
  'sync.status.connecting': 'Povezujem…',
  'sync.status.syncing': 'Sinhronizujem…',
  'sync.status.synced': 'Ažurno',
  'sync.status.offline': 'Bez veze — izmene će otići kad se vratiš',
  'sync.status.locked': 'Čeka odobrenje',
  'sync.status.schema-ahead': 'Drugi uređaj ima noviji OKANE — ažuriraj da bi nastavio',
  'sync.status.error': 'Sinhronizacija nije uspela',
  'sync.editing': '{user} menja podatke',
  'sync.lockedLead': 'Otvori OKANE na uređaju na kome je ovaj profil otvoren, idi na Podešavanja → Sinhronizacija i odobri ovaj ako prikazuje isti kod:',
  'sync.waitingTitle': 'Uređaji koji traže pristup',
  'sync.waitingLead': 'Odobri samo uređaj koji prikazuje isti kod — to dokazuje da je baš onaj koji misliš.',
  'sync.aDevice': 'Uređaj',
  'sync.approve': 'Odobri',
  'sync.approved': '{name} sada može da se sinhronizuje',
  'sync.now': 'Sinhronizuj sada',
  'sync.why.later-here': 'oba su menjala; zadržana kasnija izmena sa ovog uređaja',
  'sync.why.later-elsewhere': 'oba su menjala; zadržana kasnija izmena sa drugog uređaja',
  'sync.why.deleted-here': 'obrisano ovde, pa je izmena sa drugog uređaja odbačena',
  'sync.why.deleted-elsewhere': 'obrisano drugde, pa je izmena sa ovog uređaja odbačena',
  'sync.why.constraint': 'nije moglo da se zadrži: sukobilo se s drugim redom',
  'sync.wrongPassphrase': 'To nije lozinka.',
  'sync.wrongRecovery': 'To nije ključ za oporavak.',
  'sync.refused': 'Ne u šifrovanom profilu: to bi ga promenilo na svakom uređaju.',
  'sync.conflicts': {
    one: '{count} izmena spojena — pogledajte',
    few: '{count} izmene spojene — pogledajte',
    other: '{count} izmena spojeno — pogledajte',
  },
  'settings.syncTitle': 'Šifrovana sinhronizacija s kraja na kraj',
  'settings.cloudTitle': 'Ili je čuvaj na našem serveru',
  'sync.hideCode': 'Sakrij kod',
  'sync.scanDevice': 'Skeniraj kod uređaja',
  'sync.scanToJoin': 'Skeniraj kod sa uređaja koji se sinhronizuje',
  'sync.showDeviceCode': 'Prikaži kod za skeniranje',
  'sync.qrDeviceLead': 'Skeniraj ovo uređajem na kome je profil otvoren: on odobrava ovaj, bez upoređivanja cifara.',
  'sync.scannedVerified': '{name} — ključ odgovara kodu',
  'sync.approveElsewhere': 'Taj kod je za uređaj na kome je šifrovani profil otvoren: skeniraj ga njime.',
  'error.sync-no-device': 'Taj uređaj ne čeka u ovom profilu.',
  'error.sync-key-mismatch': 'Ključ tog uređaja nije onaj koji kod prikazuje. Ne odobravaj ga.',
  'cloud.encryptTitle': 'Šifruj ovaj profil',
  'cloud.encrypt': 'Šifruj ovaj profil',
  'cloud.encryptLead': 'Neka bude šifrovano s kraja na kraj: isti finansijski podaci i isti ljudi, ali server više ne može da ih čita. Čuva se na svakom uređaju i radi bez mreže. Uređaje svake osobe tada treba jednom odobriti — QR kodom ili poređenjem šest cifara.',
  'cloud.encryptConfirm': 'Šifrovati profil sada? Ono što neko drugi upiše narednih nekoliko sekundi može da se izgubi, a svaki drugi uređaj tada treba jednom odobriti.',
  'cloud.encryptDone': 'Šifrovano. Zapiši ključ za oporavak, pa nastavi: profil se otvara kao šifrovan, a čitljive kopije na serveru više nema.',
  'cloud.encryptContinue': 'Zapisao/la sam ga — nastavi',
  'sync.status.gone': 'Više nisi u ovom profilu',
  'gate.kind': 'Profil šifrovan s kraja na kraj',
  'gate.lead': 'Ovaj uređaj još nema njen ključ. Ništa od nje ne može da se prikaže dok ga ne dobije.',
  'gate.signIn': 'Prijavi se ponovo',
  'gate.ownerTitle': 'Otvori je ovde',
  'gate.open': 'Otvori profil',
  'gate.opening': 'Otvaram…',
  'gate.orApprove': 'Ili odobri ovaj uređaj sa nekog na kome je profil otvoren, ako prikazuje isti kod:',
  'gate.openAnother': 'Otvori drugi profil',
  'gate.onItsOwn': 'Koristi ovaj uređaj samostalno',
  'gate.signOut': 'Odjavi se',
  'cloud.encrypted': 'šifrovana',
  'sync.status.signed-out': 'Odjavljen si — izmene čekaju ovde dok se ne prijaviš',
  'states.title': 'Gde su tvoji finansijski podaci',
  'states.lead': 'Na ovom uređaju ili u oblaku, čitljiva ili šifrovana. Izaberi gde treba da bude.',
  'states.readable': 'Čitljiva',
  'states.encrypted': 'Šifrovana',
  'states.row.device': 'Ovaj uređaj',
  'states.row.cloud': 'Oblak',
  'states.local': 'Lokalna',
  'states.sealed': 'Lokalna, šifrovana',
  'states.cloud': 'Oblak',
  'states.vault': 'Oblak, šifrovana',
  'states.localLead': 'Samo ovde; otvara se bez lozinke',
  'states.sealedLead': 'Samo ovde; otvara se lozinkom',
  'states.cloudLead': 'Na našem serveru, deljena; mogli bismo da je čitamo',
  'states.vaultLead': 'Na svakom uređaju s kojim je deliš; ne možemo da je čitamo',
  'states.here': 'Tvoji finansijski podaci su ovde',
  'states.working': 'Radim…',
  'states.twoSteps': 'Dva koraka: prvo {first}, pa {second}. Drugi se ovde ponovo nudi kad prvi bude gotov.',
  'states.step.up': 'preseli je u oblak',
  'states.step.down': 'preseli je na ovaj uređaj',
  'states.step.seal': 'šifruj je ovde',
  'states.step.unseal': 'dešifruj je ovde',
  'states.step.sealedUp': 'preseli je u oblak, šifrovanu',
  'states.step.sealedDown': 'preseli je na ovaj uređaj, šifrovanu',
  'states.step.encrypt': 'šifruj je u oblaku',
  'states.step.decrypt': 'dešifruj je u oblaku',
  'states.do.up': 'Finansijski podaci idu na OKANE server, koji može da ih čita; kopija na ovom uređaju se briše. Usput se prijavljuješ.',
  'states.do.down': 'Finansijski podaci dolaze na ovaj uređaj, čitljivi, i brišu se sa servera.',
  'states.do.seal': 'Izaberi lozinku: ovaj uređaj će je tražiti svaki put kad se OKANE otvori. Čitljiva kopija se briše.',
  'states.do.unseal': 'Finansijski podaci se dešifruju na ovom uređaju i od sada se otvaraju bez lozinke.',
  'states.do.sealedUp': 'Postaje šifrovani profil u oblaku, s istom lozinkom i ključem za oporavak; drugi uređaji joj se pridružuju lozinkom ili tvojim odobrenjem.',
  'states.do.sealedDown': 'Ostaje samo na ovom uređaju, i dalje šifrovana istom lozinkom i ključem za oporavak; šifrovani profil u oblaku se briše.',
  'states.do.encrypt': 'Isti finansijski podaci, s istim ljudima, postaju šifrovani s kraja na kraj; server briše čitljivu kopiju.',
  'states.do.decrypt': 'Isti finansijski podaci, s istim ljudima, vraćaju se na server čitljivi; svaki uređaj ih otvara odatle.',
  'states.go.up': 'Preseli u oblak',
  'states.go.down': 'Preseli na ovaj uređaj',
  'states.go.seal': 'Šifruj',
  'states.go.unseal': 'Dešifruj',
  'states.go.sealedUp': 'Preseli u oblak',
  'states.go.sealedDown': 'Preseli na ovaj uređaj',
  'states.go.encrypt': 'Šifruj ovaj profil',
  'states.go.decrypt': 'Dešifruj ovaj profil',
  'states.ownerOnly': 'To može samo vlasnik ovog profila.',
  'states.shared': 'Drugi dele ovaj profil: može da napusti oblak tek kad u njemu nema nikog drugog.',
  'unlock.title': 'Tvoji finansijski podaci su šifrovani',
  'unlock.lead': 'Upiši lozinku da je otvoriš na ovom uređaju.',
  'unlock.open': 'Otvori',
  'cloud.deleteLead': 'Brisanje ovog profila ga briše za sve u njemu, na svakom uređaju. Ne može da se poništi.',
  'cloud.deleteOrg': 'Obriši „{name}“',
  'cloud.deleteConfirm': 'Obrisati „{name}“ za sve u njoj? Ovo ne može da se poništi.',
  'ledgers.title': 'Profil',
  'ledgers.name': 'Naziv',
  'ledgers.create': 'Napravi',
  'ledgers.new': 'Novi profil na ovom uređaju',
  'ledgers.delete': 'Obriši ovaj profil sa ovog uređaja',
  'ledgers.deleteConfirm': 'Obrisati „{name}“ sa ovog uređaja? Nema ga nigde drugde, i ovo ne može da se poništi.',
  'filter.files': 'Fajlovi',
  'filter.attached': 'sa fajlovima',
  'filter.unattached': 'bez fajlova',
  'attach.title': 'Fajlovi',
  'attach.add': 'Priloži fajl',
  'attach.photo': 'Slikaj',
  'attach.drop': 'Slike i PDF-ovi, do 20 MB — možeš ih i prevući ili nalepiti ovde.',
  'attach.open': 'Otvori {name}',
  'attach.remove': 'Ukloni {name}',
  'attach.missing': 'nije na ovom uređaju',
  'attach.later': 'Fajlovi se zasad mogu priložiti profilu na ovom uređaju koji nije šifrovan.',
  'attach.count': {
    one: '{count} fajl',
    few: '{count} fajla',
    other: '{count} fajlova',
  },
  'error.attachment-type': 'Mogu se priložiti samo slike i PDF-ovi.',
  'error.attachment-too-big': 'Taj fajl je veći od 20 MB.',
  'error.attachment-missing': 'Tog fajla nema na ovom uređaju.',
  'error.attachment-damaged': 'Taj fajl je oštećen: nije onaj koji je priložen.',
  'settings.filesUsed': 'Priloženi fajlovi zauzimaju {used}.',
  'settings.filesUsedOf': 'Priloženi fajlovi zauzimaju {used} od {limit}.',
  'settings.storage.sealed': 'Čuva se šifrovana u skladištu ovog pregledača; otvara se samo lozinkom.',
  'attach.none': 'Nema priloženih fajlova.',
  'error.files-full': 'Fajlovi ovog profila su popunjeni: ukloni neke da bi priložio nove.',
  'attach.pending': 'još stiže',
  'attach.offline': 'treba veza',
  'attach.queued': 'čeka slanje',
  'error.attachment-pending': 'Ovaj fajl još stiže sa uređaja koji ga je priložio.',
  'error.attachment-offline': 'Ovog fajla još nema na ovom uređaju, a server nije dostupan.',
  'sync.outbox': {
    one: '{count} priložen fajl čeka slanje',
    few: '{count} priložena fajla čekaju slanje',
    other: '{count} priloženih fajlova čeka slanje',
  },
  'sync.outboxFailed': 'Nisu mogli da se pošalju: {reason}',
  'states.files': 'Fajlovi: {done} od {total}',
  'backup.filesMissing': {
    one: 'Sačuvano — ali {count} priloženi fajl nije na ovom uređaju i nije mogao da uđe.',
    few: 'Sačuvano — ali {count} priložena fajla nisu na ovom uređaju i nisu mogla da uđu.',
    other: 'Sačuvano — ali {count} priloženih fajlova nije na ovom uređaju i nisu mogli da uđu.',
  },
  'settings.restoredMissing': {
    one: 'Vraćeno — ali {count} priloženi fajl nije bio u rezervnoj kopiji.',
    few: 'Vraćeno — ali {count} priložena fajla nisu bila u rezervnoj kopiji.',
    other: 'Vraćeno — ali {count} priloženih fajlova nije bilo u rezervnoj kopiji.',
  },
  'error.zip.no-ledger': 'U toj rezervnoj kopiji nema finansijskih podataka.',
  'error.zip.locked': 'Ta rezervna kopija je zaštićena lozinkom.',
}
